<template>
	<div>
		<h2 class="title others">
			{{
				title
					? title
					: complete
					? "Print Tanda Terima Mobil"
					: "Print Work Order"
			}}
		</h2>
		<div class="row mt-3 others mb-3">
			<div class="col-12 text-center">
				<button
					class="btn btn-info "
					style="width:260px;"
					v-if="title"
					@click="$emit('tandaTangan')"
				>
					Simpan Tanda Tangan
				</button>
			</div>
			<div class="col-12 text-center mt-3">
				<button
					class="btn btn-info mr-3"
					style="width: 75px;"
					v-if="!complete"
					@click="printPDF"
				>
					Print
				</button>
				<button
					class="btn btn-info mr-3"
					style="width: 75px;"
					v-else
					@click="printPage"
				>
					Print
				</button>
				<button
					class="btn btn-danger mr-3"
					style="width: 75px;"
					@click="$emit('closeModal')"
				>
					Cancel
				</button>
				<button
					class="btn btn-success"
					v-if="title"
					style="width: 75px;"
					@click="$emit('Done')"
				>
					Finish
				</button>
			</div>
		</div>
		<div style="border: 1px solid black">
			<!-- PRINT WO START -->
			<div
				id="printMe"
				ref="printMe"
				style="background-color:white !important"
			>
				<print-header v-if="complete"></print-header>

				<h3 class="pl-3 text-center">
					{{
						complete
							? "Tanda Terima / Pengambilan Kendaraan"
							: "Work Order"
					}}
				</h3>
				<!-- <hr> -->

				<div style="padding:10px 30px" v-if="complete">
					<div class="row">
						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style="margin-top:0px; font-size:14px; font-weight: 700;"
								>
									Nama
								</div>
								<div class="col-1 font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{ capitalize(data.customer.name) }}
								</div>
							</div>
						</div>
						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style=" font-size:14px; font-weight: 700;"
								>
									C.S.O
								</div>
								<div class="col-1   font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{ data.CSO ? data.CSO : "-" }}
								</div>
							</div>
						</div>

						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style="margin-top:0px; font-size:14px; font-weight: 700;"
								>
									Alamat
								</div>
								<div class="col-1   font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{
										data.customer.address
											? data.customer.address
											: "-"
									}}
								</div>
							</div>
						</div>
						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style=" font-size:14px; font-weight: 700;"
								>
									Diperiksa Oleh
								</div>
								<div class="col-1   font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{ data.check_by ? data.check_by : "-" }}
								</div>
							</div>
						</div>
						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style="margin-top:0px; font-size:14px; font-weight: 700;"
								>
									Nomor Polisi
								</div>
								<div class="col-1   font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{
										data.customer_car.registration
											? data.customer_car.registration
											: "-"
									}}
								</div>
							</div>
						</div>
						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style="margin-top:0px; font-size:14px; font-weight: 700;"
								>
									Telepon / HP
								</div>
								<div class="col-1   font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{
										data.customer.phone_number
											? data.customer.phone_number
											: "-"
									}}
								</div>
							</div>
						</div>
						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style="margin-top:0px; font-size:14px; font-weight: 700;"
								>
									Asuransi
								</div>
								<div class="col-1   font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{ data.asuransi ? data.asuransi : "-" }}
								</div>
							</div>
						</div>
						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style="margin-top:0px; font-size:14px; font-weight: 700;"
								>
									Merk / Tipe
								</div>
								<div class="col-1   font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{
										!data.customer_car.car
											? data.customer_car.model.name
												? data.customer_car.model.name
												: "-"
											: data.customer_car.car.name
											? data.customer_car.car.name
											: "-"
									}}
								</div>
							</div>
						</div>
						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style="margin-top:0px; font-size:14px; font-weight: 700;"
								>
									Warna / Tahun
								</div>
								<div class="col-1   font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{
										data.customer_car.car_color
											? data.customer_car.car_color.name
											: data.customer_car.colour.name
									}}{{
										(data.customer_car.car_color
											? data.customer_car.car_color.name
											: data.customer_car.colour.name) &&
										data.customer_car.year
											? " / "
											: !(data.customer_car.car_color
													? data.customer_car
															.car_color.name
													: data.customer_car.colour
															.name) &&
											  !data.customer_car.year
											? "-"
											: ""
									}}{{ data.customer_car.year }}
								</div>
							</div>
						</div>

						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style="margin-top:0px; font-size:14px; font-weight: 700;"
								>
									Kilometer
								</div>
								<div class="col-1   font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{
										data.customer_car.current_km
											? data.customer_car.current_km
											: numberWithCommas(
													data.customer_car.last_km
											  )
									}}
									KM
								</div>
							</div>
						</div>
						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style="margin-top:0px; font-size:14px; font-weight: 700;"
								>
									Kondisi Accu
								</div>
								<div class="col-1   font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{
										data.condition.accu.charging
											? `C:${data.condition.accu.charging}%; `
											: ""
									}}{{
										data.condition.accu.health
											? `H:${data.condition.accu.health}%`
											: ""
									}}
								</div>
							</div>
						</div>
						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style="margin-top:0px; font-size:14px; font-weight: 700;"
								>
									No. WO
								</div>
								<div class="col-1   font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{ data.form_code }}
								</div>
							</div>
						</div>
						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style="margin-top:0px; font-size:14px; font-weight: 700;"
								>
									BBM
								</div>
								<div class="col-1   font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{ data.condition.fuel }}
								</div>
							</div>
						</div>
						<div class="col-6">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style="margin-top:0px; font-size:14px; font-weight: 700;"
								>
									Perbaikan
								</div>
								<div class="col-1   font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{
										data.customerRequest
											? data.customerRequest
											: "-"
									}}
								</div>
							</div>
						</div>
						<!-- <div class="col-6">
              <div class="row">
                <div class="col-4 contentTitle" style="margin-top:0px; font-size:14px; font-weight: 700;">Kilometer Masuk</div>
                <div class="col-1   font-weight-bold">:</div>
                <div class="col-7 contentVariable" style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"></div>
              </div>
            </div> -->
					</div>
				</div>

				<div v-if="!complete" style="padding:0 30px">
					<!-- <div style="margin-top:0px; font-size:14px; font-weight: 700;">Estimasi :</div> 
            NO WO / Tanggal 
            Nama Asuransi 
            Pemilik 
            Merk / Tipe Kendaraan 
            NO Polisi  
            Tahun / Warna
          -->
					<div class="row">
						<div class="col-6 mt-1">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style=" font-size:14px; font-weight: 700;"
								>
									NO WO
								</div>
								<div class="col-1  font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{ capitalize(data.form_code) }}
								</div>
							</div>
						</div>
						<div class="col-6 mt-1">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style=" font-size:14px; font-weight: 700;"
								>
									Tanggal
								</div>
								<div class="col-1  font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{ moment().format("MMM DD, Y") }}
								</div>
							</div>
						</div>
						<div class="col-6 mt-1">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style=" font-size:14px; font-weight: 700;"
								>
									Asuransi
								</div>
								<div class="col-1  font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{ data.asuransi ? data.asuransi : "-" }}
								</div>
							</div>
						</div>
						<div class="col-6 mt-1">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style=" font-size:14px; font-weight: 700;"
								>
									Pemilik
								</div>
								<div class="col-1  font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{ data.customer.name }}
								</div>
							</div>
						</div>

						<div class="col-6 mt-1">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style=" font-size:14px; font-weight: 700;"
								>
									Tipe Mobil
								</div>
								<div class="col-1  font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{
										!data.customer_car.car
											? data.customer_car.model.name
												? data.customer_car.model.name
												: "-"
											: data.customer_car.car.name
											? data.customer_car.car.name
											: "-"
									}}
								</div>
							</div>
						</div>
						<div class="col-6 mt-1">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style=" font-size:14px; font-weight: 700;"
								>
									Nomor Polisi
								</div>
								<div class="col-1  font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{ data.customer_car.registration }}
								</div>
							</div>
						</div>
						<div class="col-6 mt-1">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style=" font-size:14px; font-weight: 700;"
								>
									Tahun Mobil
								</div>
								<div class="col-1  font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{ data.customer_car.year }}
								</div>
							</div>
						</div>
						<div class="col-6 mt-1">
							<div class="row">
								<div
									class="col-4 contentTitle"
									style=" font-size:14px; font-weight: 700;"
								>
									Warna Mobil
								</div>
								<div class="col-1  font-weight-bold">:</div>
								<div
									class="col-7 contentVariable"
									style="display: flex; flex-direction: column; justify-content: center;  font-size: 14px;margin-top:-5px;"
								>
									{{ data.customer_car.car_color.name }}
								</div>
							</div>
						</div>
					</div>
					<br />
					<div class="row" style="margin-top:-10px;">
						<table class="table text-center">
							<thead>
								<th>No.</th>
								<th>J / P</th>
								<th>Tipe Pengerjaan</th>
								<th>Nama Jasa / Part</th>

								<th>Deskripsi</th>
								<th>Jumlah</th>
							</thead>
							<tbody
								v-for="(estimationPart,
								index) in estimationData"
								:key="estimationPart.id"
							>
								<tr>
									<td>{{ index + 1 }}</td>
									<td>{{ estimationPart.sparepart_type }}</td>
									<td>
										{{
											estimationPart.type
												? estimationPart.type
												: "-"
										}}
									</td>
									<td>
										{{ estimationPart.alias }}
										{{
											estimationPart.extension
												? `- ${estimationPart.extension}`
												: ""
										}}
									</td>

									<td>{{ estimationPart.part_number }}</td>
									<td>{{ estimationPart.amount }}</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div class="row  ">
						<div class="col-6 text-left">
							<h5>
								Pekiraan Tanggal Selesai :
								{{
									new moment(data.finishDate).format(
										"MMM DD, YYYY"
									)
								}}
							</h5>
						</div>
						<div class="col-6 text-right">
							<h5>
								Jakarta ,
								{{ new moment().format("MMM DD, YYYY") }}
							</h5>
						</div>
					</div>

					<div class="row   rowStyle">
						<div class="col-4">
							<table
								class="table table-borderless text-center w-100"
							>
								<thead>
									<th></th>
									<th></th>
									<th>TTD</th>
									<th>Jam</th>
								</thead>
								<tbody>
									<tr style="height:50px !important">
										<td
											style="vertical-align:bottom !important"
										>
											1.
										</td>
										<td
											style="vertical-align:bottom !important"
										>
											Kepala Bengkel
										</td>
										<td
											style="vertical-align:bottom !important"
										>
											..............
										</td>
										<td
											style="vertical-align:bottom !important"
										>
											..............
										</td>
									</tr>
									<tr style="height:50px !important">
										<td
											style="vertical-align:bottom !important"
										>
											2.
										</td>
										<td
											style="vertical-align:bottom !important"
										>
											SA
										</td>
										<td
											style="vertical-align:bottom !important"
										>
											..............
										</td>
										<td
											style="vertical-align:bottom !important"
										>
											..............
										</td>
									</tr>
									<tr style="height:50px !important">
										<td
											style="vertical-align:bottom !important"
										>
											3.
										</td>
										<td
											style="vertical-align:bottom !important"
										>
											Forman
										</td>
										<td
											style="vertical-align:bottom !important"
										>
											..............
										</td>
										<td
											style="vertical-align:bottom !important"
										>
											..............
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="col-8 pl-3" style="padding-right:0">
							<table
								class="table table-bordered"
								style=" table-layout: fixed;"
							>
								<thead>
									<th>B/P<br />TTD</th>
									<th>L/K<br />TTD</th>
									<th>DEMPUL<br />TTD</th>
									<th>CAT<br />TTD</th>
									<th>POLES<br />TTD</th>
									<th>FORMAN<br />TTD</th>
								</thead>
								<tbody>
									<tr style="height:130px !important">
										<td
											style="vertical-align : bottom !important;font-size:12px"
										>
											Nama<br />
											Tanggal<br />
											Jam<br />
										</td>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
									</tr>
								</tbody>
							</table>
							<!-- <div class="row">
                  <div class="col-md border border-secondary" style="padding:0">
                    <div class=" w-100 p-5" style="border-bottom:1px solid black;">
                      <h6>B/P<br>TTD</h6>
                    </div>
                    <div style="height:200px">
                      <div style="position:absolute;bottom : 0" class="pl-2">
                        Nama<br>
                        <br>
                        Tanggal<br>
                        <br>
                        Jam<br>
                      </div>
                    </div>
                  </div>
                  <div class="col-md border border-secondary" style="padding:0">
                    <div class=" w-100 p-5" style="border-bottom:1px solid black;">
                      <h6>L/K<br>TTD</h6>
                    </div>
                    <div style="height:200px">
                      
                    </div>
                  </div>
                  <div class="col-md border border-secondary" style="padding:0">
                    <div class=" w-100 p-5" style="border-bottom:1px solid black;">
                      <h6>DEMPUL<br>TTD</h6>
                    </div>
                    <div style="height:200px">

                    </div>
                    
                  </div>
                  <div class="col-md border border-secondary" style="padding:0">
                    <div class=" w-100 p-5" style="border-bottom:1px solid black;">
                      <h6>CAT<br>TTD</h6>
                    </div>
                    <div style="height:200px">
                      
                    </div>
                  </div>
                  <div class="col-md border border-secondary" style="padding:0">
                    <div class=" w-100 p-5" style="border-bottom:1px solid black;">
                      <h6>POLES<br>TTD</h6>
                    </div>
                    <div style="height:200px">
                      
                    </div>
                  </div>
                  <div class="col-md border border-secondary" style="padding:0">
                    <div class=" w-100 p-5" style="border-bottom:1px solid black;">
                      <h6>FORMAN<br>TTD</h6>
                    </div>
                    <div style="height:200px">
                      
                    </div>
                  </div>
                </div> -->
						</div>
					</div>
				</div>

				<!-- <hr>
        <div style="padding:0 30px">
          <div style="margin-top:0px; font-size:14px; font-weight: 700;">Dokumen F. C. :</div>
          <div class="row">
            <div class="col-4" style="font-size:16px">
              <span style="font-size:20px">-</span> Polis
            </div>
            <div class="col-4" style="font-size:16px">
              <span style="font-size:20px">-</span> STNK
            </div>
            <div class="col-4" style="font-size:16px">
              <span style="font-size:20px">{{ data.condition.checklist.FRONT_SIM ? '✔' : '✘' }}</span> SIM
            </div>
            <div class="col-4" style="font-size:16px">
              <span style="font-size:20px">{{ data.condition.checklist.FRONT_KTP ? '✔' : '✘' }}</span> KTP
            </div>
            <div class="col-4" style="font-size:16px">
              <span style="font-size:20px">-</span> Laporan Polisi
            </div>
            <div class="col-4" style="font-size:16px">
              <span style="font-size:20px">-</span> Form Klaim
            </div>
          </div>
        </div> -->

				<div style="padding:0 30px" v-if="complete">
					<hr v-if="complete" style="margin-top:0px" />
					<div
						style="margin-top:0px; font-size:14px; font-weight: 700;"
					>
						Kondisi Interior / Kelengkapan :
					</div>
					<div class="row">
						<div
							class="col-3"
							style="font-size:16px"
							v-for="check in internalConditions"
						>
							<!-- {{check.value.desc}} -->
							<span style="font-size:20px;">{{
								check.value.condition == "Ada, Kondisi Oke"
									? "✔"
									: check.value.condition == "Tidak Ada"
									? "—"
									: "✘"
							}}</span>
							<span style="font-weight:bold;" class="ml-1">{{
								check.item
							}}</span>
							<div v-if="check.value.desc">
								<span>- {{ check.value.desc }}</span>
							</div>
						</div>
					</div>
					<hr v-if="complete" />
				</div>

				<div style="padding:0 30px" v-if="complete">
					<!-- <div style="margin-top:0px; font-size:14px; font-weight: 700;margin-bottom:10px">Kondisi Exterior :</div> -->

					<!-- Damages Start -->
					<div class="row">
						<div class="col-4 mt-auto mb-auto pl-3">
							<h2>Kondisi Exterior</h2>
						</div>
						<div class="col-4" v-for="key in listFigure">
							<b>{{ translatePart(key) }}</b>
							<img
								:src="
									env.baseImage +
										'/' +
										figureOverall[key].image[0]
								"
								class="w-100"
							/>
						</div>
						<!-- <template v-for="(module, index) in dictionary">
              <div v-if="index > 0 && index % 2 == 0" class="col-12" >
                <hr>
              </div>
              <div class="col-6 row   mb-2"  :key="index"  >
                <div class="col-md-4">
                  <h4 class="ml-2">{{module.value}}</h4>
                  
                </div>
                <div class="col-md-8">
                  <div v-if="damages[module.key].length > 0">
                    <ul>
                      <li style="margin-bottom:3px" v-for="damage in damages[module.key]">{{damage}}</li>
                    </ul>
                  </div>
                  <div v-else>
                    <ul><li style="list-style-type: none;">Tidak Ada Kerusakan</li></ul>
                  </div>
                </div>
              </div>
              
            </template> -->
						<!-- <div class="col-md-4" style="padding:0 20px">
              <img
                v-if="data.condition.figureOverall[module.key].image != null && data.condition.figureOverall[module.key].image.length > 0"
                :src="data.condition.figureOverall[module.key].image[0]"
                class="w-100">
              <p class="text-center">{{ data.condition.figureOverall[module.key].desc }}</p>
            </div> -->
						<!-- <div class="col-md-8">
              <h4 class="ml-2">{{module.value}}</h4>
              <div v-if="damages[module.key].length > 0">
                <p v-for="damage in damages[module.key]">• {{damage}}</p>
              </div>
              <div v-else>Tidak ada kerusakan</div>
            </div> -->
					</div>
					<div class="row text-center" v-if="showNewLegend">
						<div class=" col pl-4">
							<i class="fa fa-circle fa-lg mr-2" style="color:#29BC53"></i> Boncel
						</div>
						<div class="col pl-4">
							<i class="fa fa-circle fa-lg mr-2" style="color:#007ED9"></i> Baret
						</div>
						<div class="col pl-4">
							<i class="fa fa-circle fa-lg mr-2" style="color:#FFDD05"></i> Penyok
						</div>
						<div class="col pl-4">
							<i
								class="fa fa-circle fa-lg mr-2" style="color:#FF0000"
							></i>
							Pecah
						</div>
					</div>
					<div class="row text-center" v-else>
						<div class=" col pl-4">
							<i class="fa fa-circle fa-lg mr-2"></i> Boncel
						</div>
						<div class="col pl-4">
							<i class="fa fa-grip-lines fa-lg mr-2"></i> Baret
						</div>
						<div class="col pl-4">
							<i class="fa fa-times fa-lg mr-2"></i> Penyok
						</div>
						<div class="col pl-4">
							<i
								class="fa fa-exclamation-triangle fa-lg mr-2"
							></i>
							Pecah
						</div>
					</div>
					<!-- Damages End -->
					<hr />
					<div class="row" style="min-height:120px">
						<div class="col-4">
							<div
								style="margin-top:0px; font-size:14px; font-weight: 700;"
							>
								Yang Menyerahkan
							</div>
							<div
								v-if="
									data.condition.ttdCustomer &&
										data.condition.ttdCustomer != ''
								"
							>
								<img
									:src="
										env.baseImage +
											'/' +
											data.condition.ttdCustomer
									"
									style="min-height:100px;height:auto;width:45%"
									alt="No Signature Provided"
								/>
							</div>
							<div v-else style="height:100px"></div>
							<h5>{{ data.customer.name }}</h5>
						</div>
						<div class="col-4">
							<div
								style="margin-top:0px; font-size:14px; font-weight: 700;"
							>
								Yang Menerima
							</div>
							<div v-if="user.user_ttd && user.user_ttd != ''">
								<img
									:src="env.baseImage + '/' + user.user_ttd"
									style="min-height:100px;height:auto;width:45%"
									alt="No Signature Provided"
								/>
							</div>
							<div v-else style="height:100px"></div>
							<h5>{{ user.name }}</h5>
						</div>
						<div class="col-4">
							<div
								style="margin-top:0px; font-size:14px; font-weight: 700;"
							>
								Jakarta, {{ moment().format("DD MMMM YYYY") }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- PRINT WO END -->
		</div>
	</div>
</template>

<script>
import MultiSelect from "vue-multiselect";
import printHeader from "@/components/print/print_header.vue";
import moment from "moment";
import jsPDF from "jspdf";
import env from "@/env";
import html2canvas from "html2canvas";

export default {
	data() {
		return {
			moment,
			env,
			user: this.$store.state.userData.userData,
			showNewLegend : false,
			placeholder: require("@/assets/img/placeholder.png"),
			internalConditions: [],
			figureGrouping: {
				front: [
					"front_bumper",
					"front_left_light",
					"front_right_light",
					"front_windshield",
					"grill",
					"left_fog_light",
					"right_fog_light"
				],
				rear: [
					"rear_bumper",
					"rear_left_light",
					"rear_right_light",
					"rear_windshield"
				],
				left: [
					"front_left_door",
					"front_left_fender",
					"front_left_wheel",
					"rear_left_door",
					"rear_left_fender",
					"rear_left_wheel"
				],
				right: [
					"front_right_door",
					"front_right_fender",
					"front_right_wheel",
					"rear_right_door",
					"rear_right_fender",
					"rear_right_wheel"
				],
				atap: ["roof", "sunroof"]
			},
			listFigure: ["front", "rear", "left", "atap", "right"],
			damages: {
				front: [],
				rear: [],
				left: [],
				right: [],
				atap: []
			},
			dictionary: [
				{ key: "front", value: "Depan" },
				{ key: "rear", value: "Belakang" },
				{ key: "left", value: "Kiri" },
				{ key: "right", value: "Kanan" },
				{ key: "atap", value: "Atap" }
			],
			figureOverall: null
		};
	},
	props: [
		"form_code",
		"data",
		"estimationData",
		"complete",
		"title",
		"checklistSettings"
	],
	components: {
		MultiSelect,
		printHeader
	},
	async mounted() {
		// console.log(env)
		// this.$set(this, 'urlStart' , env.baseImage)
		// console.log(this.urlStart)
		let dataCreated = new moment(this.data.created_at)
		let dateLegendChange = new moment('2022-06-14 15:00')

		if(dataCreated.diff(dateLegendChange , 'minutes') >= 0)
			this.showNewLegend = true
		// console.log(dataCreated.diff(dateLegendChange , 'minutes'))

		this.figureOverall = this.data.condition.figureOverall.sedan
			? this.data.condition.figureOverall.sedan
			: this.data.condition.figureOverall;

		this.internalConditions = await this.parseInternalCondition(
			this.checklistSettings
				? this.checklistSettings
				: this.data.condition.checklist
				? this.data.condition.checklist
				: []
		);

		await this.parseExternalCondition(this.data.condition.figure);
		// this.printPage();
	},
	watch: {
		"selected.woStep"() {
			this.form.step_id = this.selected.woStep
				? this.selected.woStep.id
				: "";
		},
		"selected.laborer"() {
			this.form.labourer_id = this.selected.laborer
				? this.selected.laborer.id
				: "";
		}
	},
	methods: {
		printPDF() {
			this.$http({
				url: "/api/v1/workorder/print/printDoc",
				method: "post",
				user: this.$store.state.userData.userData,
				data: {
					type: "printWO",
					data: {
						form_code: this.data.form_code,
						// created_at : this.printData.start_date.slice(0, 11),
						registration: this.data.customer_car.registration,
						car_name: this.data.customer_car.car.name,
						customer_name: this.data.customer.name,
						year: this.data.customer_car.year,
						color: this.data.customer_car.car_color.name,
						work_order_data: this.estimationData,
						insurance_name: this.data.asuransi,
						finish_date: new moment(this.data.finishDate).format(
							"DD/MM/YYYY"
						)
					}
				}
			})
				.then(resp => {
					this.noteTime();
					let data = resp.data.data;
					console.log(data);
					// printJS(env.baseImage + '/' + data)
					// window.open()
					var prntWin = window.open("");
					prntWin.document.write(
						"<html><head><title>" +
							name +
							"</title></head><body>" +
							'<iframe width="100%" height="100%" name="plugin" src="' +
							env.baseImage +
							"/" +
							data +
							'"></iframe></body></html>'
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		translate(arrText) {
			let string = "";
			for (var i = 0; i < arrText.length; i++) {
				if (arrText[i] == "Depan") string += "FR ";
				else if (arrText[i] == "Belakang") string += "RR ";
				else if (arrText[i] == "Kiri") string += "LH ";
				else if (arrText[i] == "Kanan") string += "RH ";
				else string += arrText[i] + " ";
			}
			console.log(string);

			return string;
		},
		printPage() {
			let styles = null;
			if (!this.complete) {
				styles = {
					name: "_blank",
					specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
					styles: [
						"https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css",
						"https://unpkg.com/kidlat-css/css/kidlat.css",
						"/custom.css",
						"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.0/css/all.min.css"
					]
				};
			} else {
				styles = {
					name: "_blank",
					specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
					styles: [
						"https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css",
						"https://unpkg.com/kidlat-css/css/kidlat.css",
						"/my.css",
						"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.0/css/all.min.css"
					]
				};
			}

			this.$htmlToPaper("printMe", styles, () => {
				console.log("Done");
				this.$http({
					url: "/api/v1/workorder/print/printDoc",
					method: "post",
					data: {
						type: "printTTM",
						form_code: this.data.form_code
					}
				})
				.then(resp => {
					// let data = resp.data.data;
					// console.log(data);
					// var prntWin = window.open("");
					// prntWin.document.write(
					// 	"<html><head><title>" +
					// 		name +
					// 		"</title></head><body>" +
					// 		'<iframe width="100%" height="100%" name="plugin" src="' +
					// 		env.baseImage +
					// 		"/" +
					// 		data +
					// 		'"></iframe></body></html>'
					// );

					// prntWin.print();
				})
				.catch(err => {
					console.log(err);
				});
			});

			// let divToSave = document.getElementById('printMe')
			// console.log(divToSave)

			// html2canvas(divToSave).then(function (canvas) {

			//   console.log(canvas)
			//   var imgData = canvas.toDataURL(
			//       'image/png');
			//   console.log(imgData)
			//   // var doc = new jsPDF('p', 'mm');
			//   // doc.addImage(imgData, 'PNG', 700, 500);
			//   // doc.save('sample-file.pdf');

			// })

			// .then((canvas) => {
			//   console.log(canvas)
			//    let doc = new jsPDF()
			//     doc.addHTML(canvas , 200 , 200 , {
			//       'background-color': '#fff'
			//     }, function () {
			//       doc.save('Tanda Terima.pdf')
			//     })
			// })
		},
		parseInternalCondition(checklist) {
			console.log(checklist);
			return Object.entries(checklist).map(x => {
				return {
					item: this.toCapitalizedWords(
						x[0].toLowerCase().split("_")[1]
					),
					value: x[1]
				};
			});

			//Old Parser 2
			// return Object.keys(checklist).map((x)=>{return this.toCapitalizedWords(x.toLowerCase())})

			//Old Parser

			// var list = {}
			// for(var i in checklist) list[i.split("_")[0]] = 1;
			// return Object.keys(list).sort();
		},
		parseExternalCondition(figure) {
			for (var i in figure) {
				for (var j in figure[i]) {
					if (figure[i][j] && figure[i][j].desc != "") {
						this.damages[i].push(
							`${this.translate(
								this.toCapitalizedWords(j).split(" ")
							)} : '${figure[i][j].desc}'`
						);
					}
				}
			}
		},
		noteTime() {
			this.$http
				.get(`/api/v1/workorder/${this.data.form_code}/detail/print`)
				.then(resp => {
					console.log("Print Lembar Kerja successfully noted");
				})
				.catch(err => {
					console.log(err);
				});
		},
		translatePart(str) {
			let strSplit = str.split("_").reverse();

			for (var i = 0; i < strSplit.length; i++) {
				if (strSplit[i] == "front") strSplit[i] = "depan";
				else if (strSplit[i] == "rear") strSplit[i] = "belakang";
				else if (strSplit[i] == "left") strSplit[i] = "kiri";
				else if (strSplit[i] == "right") strSplit[i] = "kanan";
				else if (strSplit[i] == "wheel") strSplit[i] = "roda";
				else if (strSplit[i] == "door") strSplit[i] = "pintu";
				else if (strSplit[i] == "light") strSplit[i] = "lampu";
				else if (strSplit[i] == "car") strSplit[i] = "mobil";
				else if (strSplit[i] == "window") strSplit[i] = "kaca";

				strSplit[i] =
					strSplit[i].charAt(0).toUpperCase() + strSplit[i].slice(1);
			}

			return strSplit.join(" ");
		}
	}
};
</script>

<style scoped>
hr {
	margin-top: 7px;
}
.border-bot {
	border-bottom: 1px solid #ccc;
}

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	margin-top: -5px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
	/* WebKit, Blink, Edge */
	color: #666;
}

.input--style-4:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #666;
	opacity: 1;
}

.input--style-4::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #666;
	opacity: 1;
}

.input--style-4:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #666;
}

.input--style-4:-ms-input-placeholder {
	/* Microsoft Edge */
	color: #666;
}

.label {
	font-size: 16px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 30px;
	cursor: pointer;
	font-size: 16px;
	color: #666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
	background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
	display: block;
}

.radio-container .checkmark:after {
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 12px;
	height: 12px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	background: #57b846;
}

.checkmark {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e5e5e5;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.input-group {
	position: relative;
	/* margin-bottom: 22px; */
	padding: 20px;
}

.input-group-icon {
	position: relative;
}

.input-icon {
	position: absolute;
	font-size: 18px;
	color: #999;
	right: 18px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
	font-size: 40px;
	color: #525252;
	margin-bottom: 40px;
	text-align: center;
}

.companyDetails {
	margin-bottom: 5px;
	font-size: 0.6rem;
}
/* .documentTitle{
  font-size: 40px;
  border: 1px solid black;
  border-radius: 10px;
  padding:20px 30px;
} */
.contentTitle {
	font-size: 14px;
	font-weight: 700;
	margin-top: 0px;
}
.contentVariable {
	display: flex;
	flex-direction: column;
	justify-content: center;
	font-size: 14px;
	margin-top: -5px;
	font-weight: bold;
}

.color-green {
		color : #29BC53;
	}
.color-blue {
	color : #007ED9;
}
.color-yellow {
	color : #FFDD05;
}
.color-red {
	color : #FF0000;
}
</style>
